// Copyright (c) Bentley Systems
export class ArchiveAddVm {
  private isImportMapping: boolean;
  private isUpdateUserNames: boolean;
  public alertText?: string;
  public isMappingUpload: boolean = false;

  constructor(dataResult: any) {
    this.isImportMapping = dataResult.isImportMapping === true;
    this.isUpdateUserNames = dataResult.isUpdateUserNames === true;

    if (this.isImportMapping) {
      this.alertText =
        'Only Excel files with the following headers are allowed for import: "iTwin ID", "Object Name", "Attribute Collection".';
      this.isMappingUpload = true;
    }
    if (this.isUpdateUserNames) {
      this.alertText =
        'Only Excel files with the following headers are allowed for update names: "TechnicalFieldName", "UserFieldName".';
      this.isMappingUpload = true;
    }
  }
}
